/**
 * Gas cost constants for EVM operations
 *
 * Provides comprehensive gas cost constants for:
 * - EVM opcodes
 * - Transaction types
 * - Storage operations
 * - Block limits
 *
 * @module GasCosts
 */

export { BLOCK_GAS_LIMITS, GAS_COSTS, TRANSACTION_COSTS } from "./constants.js";
